module.exports = __webpack_public_path__ + "static/media/matching_invite_desktop@2x.2256c5f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/themeListing/matching_invite_desktop@2x.jpg
// module id = 1688
// module chunks = 46